import React, { useState, useEffect, useContext, useCallback } from "react"
import queryString from "query-string"
import SelectedFilterCategory from "../../selected-filter-category"
import SearchResultCard from "../../search-result-card"
import SearchField from "../../search-field"
import { GlobalAuthContext } from "../../../context/authContext"
import axios from "../../../constants/axios"
import "./searchPageContentBox.scss"

const SearchPageContentCards = ({
  experienceLevel,
  salary,
  seniority_level,
  job_type,
  jobLocation,
  searchValue,
  query_params,
  handleTextSearchChange,
  handleJobTypeChange,
  handleSeniorityLevelChange,
  handleLocationChange,
  handleSalaryChange,
  handleExperienceChange,
}) => {
  const [loading, setLoading] = useState(false)
  const { state, dispatch } = useContext(GlobalAuthContext)

  const fetchJobList = async () => {
    setLoading(true)

    const queryParamsString = queryString.stringify(query_params)
    let apiUrl = `https://api.wdnexus.com/api/jobs/job/search/?`

    apiUrl += queryParamsString

    try {
      const res = await axios.get(apiUrl)

      if (res?.status === 200) {
        dispatch({
          type: "COMPANY_JOB_POSTED",
          payload: { ...res?.data, results: res?.data?.results },
        })
      }
    } catch (error) {
      console.error("Error fetching job list:", error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchJobList()
  }, [searchValue, query_params])

  return (
    <div className="wdn-search-content-wrapper">
      <SearchField value={searchValue} onChange={handleTextSearchChange} />

      {jobLocation.id || job_type.length > 0 || seniority_level.length > 0 ? (
        <SelectedFilterCategory
          totalItem={state?.job_posted_list?.results?.length}
          jobLocation={jobLocation}
          job_type={job_type}
          seniority_level={seniority_level}
          handleJobTypeChange={handleJobTypeChange}
          handleSeniorityLevelChange={handleSeniorityLevelChange}
          handleLocationChange={handleLocationChange}
          handleSalaryChange={handleSalaryChange}
          handleExperienceChange={handleExperienceChange}
        />
      ) : (
        ""
      )}

      <div className="row">
        {state?.job_posted_list?.results?.length > 0 ? (
          state?.job_posted_list?.results.map(result => (
            <div className="col-xxl-4 col-md-6" key={result.id}>
              <SearchResultCard
                companyName={result.industry}
                post={result.title}
                companyLogo={result.company.avatar}
                address={result.address}
                minExperience={result.minExperience}
                baseSalary={result.baseSalary}
                lastUpdated={result.job_created}
                brief={result.job_description}
                jobType={result.job_type}
              />
            </div>
          ))
        ) : (
          <div className="text-center">
            <h1>Sorry, no jobs found.</h1>
            {state?.user?.company?.id && <p>You haven't posted any job yet.</p>}
          </div>
        )}
      </div>
    </div>
  )
}

export default SearchPageContentCards
